import React from 'react';
import { getMutationMode, useTranslate } from 'react-admin';
import { Tooltip, IconButton } from '@material-ui/core';
import ContentSave from '@material-ui/icons/Save';
export var SaveRowButton = function (_a) {
    var dirty = _a.dirty, handleSubmit = _a.handleSubmit, invalid = _a.invalid, mutationMode = _a.mutationMode, quitEditMode = _a.quitEditMode, saving = _a.saving, undoable = _a.undoable;
    var translate = useTranslate();
    var onClick = function (evt) {
        evt.stopPropagation();
        evt.preventDefault();
        if (dirty && invalid) {
            return;
        }
        handleSubmit();
        var mode = getMutationMode(mutationMode, undoable);
        if (mode === 'undoable') {
            quitEditMode();
        }
    };
    var label = translate('ra.action.save', {
        _: 'ra.action.save',
    });
    return (React.createElement(Tooltip, { title: label },
        React.createElement(IconButton, { "aria-label": label, disabled: saving, onClick: onClick, size: "small", color: "primary" },
            React.createElement(ContentSave, null))));
};
